import { reducer as formReducer } from 'redux-form'
import alertReducer from './alertReducer'
import bundleReducer from './bundleReducer'
import bundleSelectionReducer from './bundleSelectionReducer'
import cartItemsReducer from './cartItemsReducer'
import cartMultipleManagedAddressReducer from './cartMultipleManagedAddressReducer'
import checkoutReducer from './checkoutReducer'
import clientOrdersReducer from './clientOrdersReducer'
import creditsReducer from './creditsReducer'
import currentUserReducer from './currentUserReducer'
import customerAddressReducer from './customerAddressReducer'
import customerGroupsReducer from './customerGroupsReducer'
import errorsReducer from './errorsReducer'
import featuredCategoriesReducer from './featuredCategoriesReducer'
import loadingReducer from './loadingReducer'
import managedCustomerAddressReducer from './managedCustomerAddressReducer'
import maxQuantitiesReducer from './maxQuantitiesReducer'
import myDownloadsReducer from './myDownloadsReducer'
import orderDetailsReducer from './orderDetailsReducer'
import orderFallbackReducer from './orderFallbackReducer'
import orderInvoiceReducer from './orderInvoiceReducer'
import paginatedProductsReducer from './paginatedProductsReducer'
import passwordTokenReducer from './passwordTokenReducer'
import portalPagesReducer from './portalPagesReducer'
import portalReducer from './portalReducer'
import productPageReducer from './productPageReducer'
import productsReducer from './productsReducer'
import proofingPreviewReducer from './proofingPreviewReducer'
import saveProductSuggestionsReducer from './saveProductSuggestionsReducer'
import searchQueryReducer from './searchQueryReducer'
import sessionReducer from './sessionReducer'
import statusReducer from './statusReducer'
import stockReducer from './stockReducer'
import successReducer from './successReducer'
import userReducer from './userReducer'

export default {
  sweetAlert: alertReducer,
  bundle: bundleReducer,
  bundle_selections: bundleSelectionReducer,
  cartItems: cartItemsReducer,
  cart_multiple_managed_customer_addresses: cartMultipleManagedAddressReducer,
  checkout: checkoutReducer,
  client_orders: clientOrdersReducer,
  currentUser: currentUserReducer,
  customerGroup: customerGroupsReducer,
  customer_addresses: customerAddressReducer,
  errors: errorsReducer,
  featuredCategories: featuredCategoriesReducer,
  form: formReducer,
  loading: loadingReducer,
  maxQuantities: maxQuantitiesReducer,
  myDownloads: myDownloadsReducer,
  order_details: orderDetailsReducer,
  order_fallbacks: orderFallbackReducer,
  order_invoice: orderInvoiceReducer,
  paginated_products: paginatedProductsReducer,
  portal: portalReducer,
  portal_pages: portalPagesReducer,
  products: productsReducer,
  productPage: productPageReducer,
  productSuggestions: saveProductSuggestionsReducer,
  proofing_preview: proofingPreviewReducer,
  session: sessionReducer,
  searchQuery: searchQueryReducer,
  managed_customer_addresses: managedCustomerAddressReducer,
  status: statusReducer,
  stocks: stockReducer,
  success_message: successReducer,
  user: userReducer,
  userCredits: creditsReducer,
  password_token: passwordTokenReducer
}
